import type { SVGProps } from 'react'

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 16 13"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7949 2.19767L8.23926 8.7897L6.25 6.79607L12.8155 0.206226C12.88 0.141204 12.9566 0.0895246 13.0411 0.0541403C13.1256 0.0187561 13.2162 0.000360761 13.3077 5.25334e-06C13.3993 -0.000350254 13.49 0.0173412 13.5748 0.0520686C13.6595 0.086796 13.7365 0.137878 13.8015 0.202397L13.8054 0.206226L14.7949 1.20181C14.9263 1.33425 15 1.51322 15 1.69974C15 1.88627 14.9263 2.06523 14.7949 2.19767Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M8.23712 8.79242L6.74498 10.2928C6.61472 10.424 6.43767 10.4982 6.25276 10.4989C6.06785 10.4996 5.89023 10.4268 5.75896 10.2966L5.75513 10.2928L1.20513 5.71652C1.07374 5.58417 1 5.40523 1 5.21873C1 5.03223 1.07374 4.85329 1.20513 4.72094L2.19498 3.72535C2.32502 3.59442 2.50167 3.52041 2.6862 3.51954C2.87073 3.51867 3.04808 3.59101 3.17935 3.7207L3.18373 3.72535L8.23712 8.79242Z"
      fill="currentColor"
    />
  </svg>
)
